import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Protected Route Component
export const ProtectedRoute = ({ children, adminOnly = false, superadminOnly = false, allowContador = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-tb-accent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/landing" state={{ from: location }} replace />;
  }

  // Determine default route based on role
  let defaultRoute = "/dashboard";
  if (user.role === "superadmin") {
    defaultRoute = "/superadmin";
  } else if (user.role === "contador") {
    defaultRoute = "/accounting";
  }

  // Check if user has extra menu routes that grant access to this path
  const extraRoutes = user.extra_menu_routes || [];
  const currentPath = location.pathname;
  const hasExtraAccess = extraRoutes.includes(currentPath);

  if (superadminOnly && user.role !== "superadmin") {
    return <Navigate to={defaultRoute} replace />;
  }

  if (adminOnly && !["admin", "superadmin"].includes(user.role)) {
    if (allowContador && user.role === "contador") {
      // Allow access for contador when allowContador is true
    } else if (hasExtraAccess) {
      // Allow access via extra menu permissions
    } else {
      return <Navigate to={defaultRoute} replace />;
    }
  }

  return children;
};

// Smart redirect based on user role
export const DefaultRedirect = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-tb-accent"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/landing" replace />;
  }
  
  let targetRoute = "/dashboard";
  if (user.role === "superadmin") {
    targetRoute = "/superadmin";
  } else if (user.role === "contador") {
    targetRoute = "/accounting";
  }
  return <Navigate to={targetRoute} replace />;
};
